import React, { useRef, useState } from "react"
import { Link } from "gatsby"

import Spacer from "./spacer"

const FORM_NAME = "newsletter"

const FOOTER_LINKS = [
    { label: "About Us", to: "/about" },
    { label: "Services", to: "/services" },
    { label: "Projects", to: "/projects" },
    { label: "Contact", to: "/contact" },
    { label: "Linkedin", to: "https://www.linkedin.com", external: true },
]

const Footer = React.forwardRef(function Footer({ visible, fixed }, ref) {
    return (
        <footer ref={ref} className={`p20 bg-brown white${fixed ? "" : " footer-flow"}`}>
            <div className={`footer-content${visible ? " is-visible" : ""}`}>
                <div className='grid-2-1 m-reverse m-gap-40'>
                    <div>
                        <h2>
                            Family owned.
                            <br />
                            Properly done.
                        </h2>
                    </div>
                    <div>
                        <div className='flex justify-end flex-wrap gap-4 m-justify-start'>
                            {FOOTER_LINKS.map(link => (
                                <FooterLink key={link.label} {...link} />
                            ))}
                        </div>
                    </div>
                </div>
                <Spacer />
                <div className='mb-40 mt-40'>
                    <p className='mb-10 fs-14 medium'>Newsletter</p>
                    <NewsletterForm />
                </div>
                <div className='footer-logo' role='img' aria-label='Iron Workers' />
            </div>
        </footer>
    )
})

export default Footer

function FooterLink({ label, to, external }) {
    if (external) {
        return (
            <a href={to} target='_blank' rel='noreferrer' className='button link'>
                {label}
            </a>
        )
    }
    return (
        <Link to={to} className='button link'>
            {label}
        </Link>
    )
}

function NewsletterForm() {
    const formRef = useRef(null)
    const [submitted, setSubmitted] = useState(false)

    const handleSubmit = event => {
        event.preventDefault()
        const formData = new FormData(event.target)
        fetch("/", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: new URLSearchParams(formData).toString(),
        })
            .then(() => {
                setSubmitted(true)
                formRef.current?.reset()
            })
            .catch(error => alert(error))
    }

    return (
        <form ref={formRef} name={FORM_NAME} method='POST' data-netlify='true' netlify-honeypot='bot-field' onSubmit={handleSubmit} className='flex'>
            <input type='hidden' name='form-name' value={FORM_NAME} />
            <p hidden>
                <label>
                    Don't fill this out: <input name='bot-field' />
                </label>
            </p>
            <input type='email' name='email' placeholder={submitted ? "Thanks for subscribing." : "Enter Email"} required className='input m-flex-1' />
            <button type='submit' className='footer-submit' aria-label='Subscribe'>
                <span className='footer-submit-icon' aria-hidden='true' />
            </button>
        </form>
    )
}
